module.exports = __webpack_public_path__ + "static/media/festival_02.fbf0e30a.jpg";